<template>
    <v-color-picker v-model="stringValue" mode="hex" hide-inputs />
</template>

<script setup>
    import { ref } from 'vue';

    const props = defineProps(['params']);

    const stringValue = ref(props.params.value ?? '');

    function getValue() {
        return stringValue.value;
    }

    function isPopup() {
        return true;
    }

    // ag-grid calls getValue()/isPopup() on this component's public instance to implement the
    // ICellEditor contract — only visible through defineExpose() on a <script setup> component.
    defineExpose({ getValue, isPopup });
</script>
